import { createContext } from 'react';

export const SelectedHubContext = createContext();
